import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditingSection } from '@app/features/questionnaire/components/questions/style-tab/section-editors/editing-section';
import { Questionnaire } from '@app/core/models/questionnaire.model';
import { buildRuntimePreviewContext } from '@app/features/questionnaire/components/questions/style-tab/preview/runtime-context.builder';
import { getHeaderPreviewData } from '@app/features/questionnaire/components/questions/style-tab/preview/preview-style.resolver';

@Component({
  selector: 'app-survey-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './survey-header.html',
  styleUrl: './survey-header.scss',
})
export class SurveyHeader {
  @Input() questionnaire: Questionnaire | null = null;

  get data() {
    if (!this.questionnaire) return null;
    const context = buildRuntimePreviewContext(
      this.questionnaire,
      EditingSection.HEADER
    );
    return getHeaderPreviewData(context);
  }
}
